import React from "react";
import Account from "./Account";

function UniversityAccount() {
  return (
    <>
      <div className="bg-gray-100 p-4">
        <Account />
      </div>
    </>
  );
}

export default UniversityAccount;
